import { createSafeContext } from '../../../util/createSafeContext';
import { AppRouteObject } from './AppRouteObject';

export interface AppRouteContextValue {
    routes: AppRouteObject[];
}

export const [AppRouteContextProvider, useAppRouteContext, AppRouteContext] =
    createSafeContext<AppRouteContextValue>('AppRoute');
